import { IOptionProps } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";

import { useApiService } from ".";
import { ReferentialApi, ReferentialItemDto } from "../api";

export const useReferential = (
  func: (api: ReferentialApi) => Promise<ReferentialItemDto[]>,
  asInt?: boolean,
  dependencies?: any[],
  nullable: boolean = true
): [IOptionProps[], boolean, string, Function] => {
  const api = useApiService(ReferentialApi);
  const [data, loading, error, trigger] = useApiEffect(() => func(api), dependencies);

  const newData = React.useMemo(() => {
    if (data) {
      return data?.map((p) => {
        return { value: p.idValue ? (asInt ? +p.idValue : p.idValue) : null, label: p.displayValue };
      }) as IOptionProps[];
    }
  }, [asInt, data]);

  const finalData = React.useMemo(() => {
    // if (newData && nullable) {
    //   newData.unshift({ value: undefined, label: "" } as IOptionProps);
    // }
    return newData;
  }, [newData]);

  return [finalData, loading, error, trigger];
};
